module.exports = __webpack_public_path__ + "img/toTopMini.624c4e7d.jpg";